import React, { Component } from 'react'
import './Bloc.css'
import { InfoBulle } from '../ImportAll'
import store from '../../engine/store'
import { DepList, CountryList } from '../../engine/Referentiel'
import { RechercheCommune } from '../../engine/ApiCommunicator'
import { connect } from 'react-redux'
import Select from 'react-select'

class BlocLocationField extends Component {
    constructor(props) {
        super(props)
        this.handleUpdateLocationField =
            this.handleUpdateLocationField.bind(this)
    }

    handleUpdateLocationField(key, value) {
        store.dispatch({ type: 'SET', value: { key: key, value: value } })
    }

    render() {
        /////////////////////////////////
        // définition du style du bloc //
        /////////////////////////////////
        let className = 'Bloc fade-in bloc-full'
        const style = {}
        style.display = 'table'
        style.minHeight = '122px'

        //////////////////////////////////
        // définition de l'état du bloc //
        //////////////////////////////////
        var infobulle
        if (this.props.infobulle && this.props.infobulle !== undefined) {
            infobulle = (
                <div className="infoBulleContainer">
                    <InfoBulle text={this.props.infobulle} />
                </div>
            )
        }

        var premadeContent

        if (this.props.Ville) {
            const colourStyles = {
                control: (styles) => ({
                    backgroundColor: '#EEF3F4',
                    width: '80%',
                    marginLeft: '10%',
                    marginTop: '20px',
                    borderRadius: '10px',
                    height: '45px',
                    fontSize: '16px',
                    paddingTop: '10px',
                    textAlign: 'center',
                }),
                option: (
                    styles,
                    { data, isDisabled, isFocused, isSelected }
                ) => {
                    const weight = isSelected ? 'bold' : 'regular'
                    return {
                        padding: '8px',
                        fontSize: '16px',
                        fontWeight: weight,
                    }
                },
            }

            const filterOptions = ({ label }, input) => true
            premadeContent = (
                <div>
                    <div className="labelfield">{this.props.label}</div>
                    <Select
                        blurInputOnSelect={true}
                        components={{
                            DropdownIndicator: () => null,
                            IndicatorSeparator: () => null,
                        }}
                        options={this.props.cityCodeSearch}
                        placeholder="Selectionner un code postal ou une ville"
                        filterOption={filterOptions}
                        hideSelectedOptions={false}
                        styles={colourStyles}
                        value={
                            this.props.targetDataValue
                                ? this.props.targetDataValue
                                : ''
                        }
                        onChange={(e) =>
                            this.handleUpdateLocationField(
                                this.props.linked_data_id,
                                e
                            )
                        }
                        onInputChange={(e) =>
                            RechercheCommune(e, 15, 'tech_city_code_preview')
                        }
                        noOptionsMessage={(e) => 'Pas de correspondance ...'}
                    />
                </div>
            )
        } else if (this.props.Departement) {
            const colourStyles = {
                control: (styles) => ({
                    backgroundColor: '#EEF3F4',
                    width: '80%',
                    marginLeft: '10%',
                    marginTop: '20px',
                    borderRadius: '10px',
                    height: '45px',
                    fontSize: '16px',
                    paddingTop: '10px',
                    textAlign: 'center',
                }),
                option: (
                    styles,
                    { data, isDisabled, isFocused, isSelected }
                ) => {
                    const weight = isSelected ? 'bold' : 'regular'

                    return {
                        padding: '8px',
                        fontSize: '16px',
                        fontWeight: weight,
                    }
                },
            }
            premadeContent = (
                <div>
                    <div className="labelfield">{this.props.label}</div>
                    <Select
                        components={{
                            DropdownIndicator: () => null,
                            IndicatorSeparator: () => null,
                        }}
                        blurInputOnSelect={true}
                        options={DepList}
                        placeholder="Selectionner un département (nom ou numéro)"
                        hideSelectedOptions={false}
                        styles={colourStyles}
                        value={
                            this.props.targetDataValue
                                ? this.props.targetDataValue
                                : ''
                        }
                        onChange={(e) =>
                            this.handleUpdateLocationField(
                                this.props.linked_data_id,
                                e
                            )
                        }
                    />
                </div>
            )
        } else if (this.props.Pays) {
            const colourStyles = {
                control: (styles) => ({
                    backgroundColor: '#EEF3F4',
                    width: '80%',
                    marginLeft: '10%',
                    marginTop: '20px',
                    borderRadius: '10px',
                    height: '45px',
                    fontSize: '16px',
                    paddingTop: '10px',
                    paddingLeft: '20px',
                    textAlign: 'center',
                }),

                option: (
                    styles,
                    { data, isDisabled, isFocused, isSelected }
                ) => {
                    const weight = isSelected ? 'bold' : 'regular'

                    return {
                        padding: '8px',
                        fontSize: '16px',
                        fontWeight: weight,
                    }
                },
            }
            premadeContent = (
                <div>
                    <div className="labelfield">{this.props.label}</div>
                    <Select
                        components={{
                            DropdownIndicator: () => null,
                            IndicatorSeparator: () => null,
                        }}
                        blurInputOnSelect={true}
                        options={CountryList}
                        placeholder="Selectionner un pays"
                        hideSelectedOptions={false}
                        styles={colourStyles}
                        value={
                            this.props.targetDataValue
                                ? this.props.targetDataValue
                                : ''
                        }
                        onChange={(e) =>
                            this.handleUpdateLocationField(
                                this.props.linked_data_id,
                                e
                            )
                        }
                    />
                </div>
            )
        }

        return (
            <div>
                <div className={className} style={style}>
                    {infobulle}
                    {premadeContent}
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    // standard value + value of the proposed city for form
    if (ownProps.Ville) {
        const varData = ownProps.linked_data_id
        const varCityCodeSearch = 'tech_city_code_preview'
        return {
            cityCodeSearch: state.answer[varCityCodeSearch],
            targetDataValue: state.answer[varData],
        }
    }

    return {
        targetDataValue: state.answer[ownProps.linked_data_id],
    }
}

export default connect(mapStateToProps)(BlocLocationField)
